import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer className="border-t border-[#D4AF37]/15 mt-24" data-testid="site-footer">
      <div className="mx-auto max-w-6xl px-6 py-14 grid gap-10 md:grid-cols-3">
        <div>
          <p className="font-display tracking-[0.3em] text-[#F3E5AB]">ANCIENT ORIGIN</p>
          <p className="font-serif-it text-lg text-[#A89F91] mt-3">Tales of Indian heritage, redefined.</p>
        </div>
        <div className="text-sm text-[#A89F91] space-y-2">
          <Link to="/store" className="block hover:text-[#F3E5AB]">Explore the store</Link>
          <Link to="/store?section=clearance" className="block hover:text-[#F3E5AB]">Clearance sale</Link>
          <Link to="/store?section=other" className="block hover:text-[#F3E5AB]">Heritage apparel</Link>
        </div>
        <div className="text-sm text-[#6E6558] space-y-2">
          <p>[placeholder: contact email / phone]</p>
          <p>[placeholder: studio address]</p>
          <Link to="/login" className="block hover:text-[#F3E5AB]" data-testid="footer-portal-link">Admin &amp; weaver portal</Link>
        </div>
      </div>
    </footer>
  );
}
